// extracted by mini-css-extract-plugin
export default {"reportTable":"K9yHLef5vo5nPQIhMxry"};